// auth.js
export const token = (() => {
  const studentSession = sessionStorage.getItem("studentSession");
  return studentSession ? JSON.parse(studentSession).token : null;
})();